function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#A1B4C4",
  d: "M2.08079791,5 L6.91920209,5 C7.47148684,5 7.91920209,5.44771525 7.91920209,6 C7.91920209,6.02587708 7.91819766,6.05174442 7.91619105,6.07754359 L7.37174661,13.0775436 C7.3312526,13.5981808 6.89696728,14 6.37475765,14 L2.62524235,14 C2.10303272,14 1.6687474,13.5981808 1.62825339,13.0775436 L1.08380895,6.07754359 C1.04098281,5.52692179 1.45263252,5.04583718 2.00325432,5.00301104 C2.02905349,5.00100444 2.05492082,5 2.08079791,5 Z M3,2 L3,1 C3,0.44771525 3.44771525,1.01453063e-16 4,0 L5,0 C5.55228475,-1.01453063e-16 6,0.44771525 6,1 L6,2 L8,2 C8.55228475,2 9,2.44771525 9,3 C9,3.55228475 8.55228475,4 8,4 L1,4 C0.44771525,4 -1.06752283e-12,3.55228475 -1.06759046e-12,3 C-1.0676581e-12,2.44771525 0.44771525,2 1,2 L3,2 Z"
});

function SvgIconDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.43c3dab9.svg";
export { ForwardRef as ReactComponent };